import { starOfLifeIcon } from '../../common/Icons';

const starOfLifeIcons = starOfLifeIcon('fill-darwin-neutral-900');

const TreatmentsBt: React.FC<{
    isSelected: boolean;
}> = ({ isSelected }) => {
    return (
        <div className={`menuitem  ${isSelected ? 'selected' : ''}`}>
            <div>
                <div>{starOfLifeIcons}</div>
                <p>Treatments</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                </svg>
            </div>
        </div>
    );
};

export default TreatmentsBt;
